import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Formik, Form } from 'formik';
import { Autocomplete, Checkbox, Container, FormControlLabel, IconButton, TextField, TextareaAutosize } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { sorunTipi, aksiyonSahibi } from '../../helpers/ProcessData';
import Textarea from '@mui/joy/Textarea';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState, useEffect } from 'react';
import { uygunsuzlukTipi } from "../../helpers/ProcessData"
import { useSelector } from "react-redux"
import useArge from '../../hooks/useArge';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,

};

const NihaiUrunKontrolModal = ({ open, handleClose, info, setInfo, materialCode, designCode }) => {

  const [searchUrunKodu, setSearchUrunKodu] = useState(null)
  const [searchRenkKodu, setSearchRenkKodu] = useState(null)
  const nowData = new Date()
  const currentdatetime = nowData.getDate() + "-" + (nowData.getMonth() + 1) + "-" + nowData.getFullYear()
  const currentTime = nowData.getHours() + ":" + nowData.getMinutes()
  const [isCheck, setIsCheck] = useState(false)
  const [newMaterialName, setnewMaterialName] = useState(false)

  const handleChange = (e, newValue, fieldName) => {
    // setInfo({ ...info, [e.target.name]: e.target.value, ['urun_kodu']: search ? search.MALZEMEKODU : ""  })

    // Autocomplete'ten gelen olaylar için
    if (fieldName) {
      setInfo(prevInfo => ({
        ...prevInfo,
        [fieldName]: newValue?.MALZEMEKODU || newValue || ""
      }));
    }

    // TextField'tan gelen olaylar için
    else if (e?.target) {
      const { name, value } = e.target;

      setInfo(prevInfo => {

        const newInfo = { ...prevInfo, [name]: value }

        if (isCheck && newInfo.oldData_date) {

          const dateStr = newInfo.oldData_date.split('T')
          const parts = dateStr[0].split('-')
          newInfo.date = `${parts[2]}-${parts[1]}-${parts[0]}`
          newInfo.time = dateStr[1]
        }
        else {

          newInfo.date = currentdatetime.toString()
          newInfo.time = currentTime.toString()
        }

        //?yeni ürün kodu bilgisi manuel olarak yazılırsa ürün_kodu değerini yazdır
        if (newMaterialName) {
          newInfo.urun_kodu = newInfo.newMaterialName.toUpperCase()
        }
  


        return newInfo
      })

    }
  }

  const { getFireData, putFireData, postFireData } = useArge()

  const [desenCodes, setdesenCodes] = useState([])


  //kayıt işlemini yap
  const handleSubmit = (e) => {

    e.preventDefault()

    if (info.id) {
      putFireData('NihaiUrunKontrol', info)
      getFireData("NihaiUrunKontrol")
    }
    else {
      postFireData("NihaiUrunKontrol", info)
      getFireData("NihaNihaiUrunKontroliUrun")
    }

    handleClose()

  }

  useEffect(() => {

    const data = designCode.map((item) => item.DESENKODU)
    const dataSort = data.sort()
    setdesenCodes(dataSort)

  }, [designCode])



  // checkbox fonksiyon
  const handleIsCheck = (e) => {
    const { checked, name } = e.target
    if (name === "oldData") {

      setIsCheck(checked)
    }
    else if (name === 'newMaterialName') {
      setnewMaterialName(checked)
    }
  }

  // checkbox false yap ve date bilgisini temizle
  function handleIsCheck_Reset() {
    setIsCheck(false)
    setInfo({ ...info, ['oldData_date']: "", ['newMaterialName']: "" })
  }


  return (
    <div>

      <Modal
        keepMounted
        open={open}
        onClose={() => {
          handleClose()
          handleIsCheck_Reset()
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography id="keep-mounted-modal-title" variant="h6" component="h2" color="#000000">
              Nihai Ürün Kontrol
            </Typography>

            <IconButton onClick={() => {
              handleClose()
              handleIsCheck_Reset()
            }}>
              <HighlightOffIcon sx={{ color: '#C70039', fontSize: '28px' }} />
            </IconButton>
          </Box>



          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center', p: 2, border: '1px solid gray', borderRadius: 3 }}>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, width: '100%' }}>
              <FormControlLabel
                control={
                  <Checkbox checked={isCheck} onChange={handleIsCheck} name="oldData" />
                }
                label="Geçmiş tarihli veri girişi"
              />
              {
                isCheck && <TextField
                  size='small'
                  name='oldData_date'
                  id='oldData_date'
                  type='datetime-local'
                  onChange={handleChange}
                />
              }

            </Box>
            {
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, width: '100%' }}>
                <FormControlLabel
                  control={
                    <Checkbox checked={newMaterialName} onChange={handleIsCheck} name="newMaterialName" />
                  }
                  label="Yeni malzeme adı"
                />
                {
                  newMaterialName && <TextField
                    size='small'
                    name='newMaterialName'
                    id='newMaterialName'
                    value={info.newMaterialName}
                    type='text'
                    onChange={handleChange}
                  />
                }

              </Box>
            }

          </Box>

          <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2, overflow: 'scroll', maxHeight: '550px' }} component='form' onSubmit={handleSubmit}>


            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>

              <Autocomplete
                fullWidth
                value={info.renkKodu ? info.renkKodu : searchRenkKodu}
                name='renkKodu'
                onChange={(event, newValue) => {
                  setSearchRenkKodu(newValue);
                  handleChange(event, newValue, 'renkKodu')
                }}
                id="search-select-demo"
                options={desenCodes}
                getOptionLabel={(option) => option}
                renderInput={(params) => <TextField {...params} label="Renk Kodu" />}
              />

              {/* yeni ürün kodu manuel olarak eklemek istenirse seçmeli ürün kodlarını görünümünü kapat */}
              {
                newMaterialName ?
                  (
                    ""
                  )
                  :
                  (
                    <Autocomplete
                      fullWidth
                      value={info.urun_kodu ? { MALZEMEKODU: info.urun_kodu } : searchUrunKodu}
                      name='urun_kodu'
                      onChange={(event, newValue) => {
                        setSearchUrunKodu(newValue);
                        handleChange(event, newValue, 'urun_kodu')
                      }}
                      id="search-select-demo"
                      options={materialCode}
                      getOptionLabel={(option) => option.MALZEMEKODU}
                      renderInput={(params) => <TextField {...params} label="Ürün Kodu" />}
                    />
                  )
              }


            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>


              <TextField
                fullWidth
                label="Ölçülen Numune Sayısı"
                name="olculenNumuneSayisi"
                id="olculenNumuneSayisi"
                type="text"
                variant="outlined"
                value={info.olculenNumuneSayisi}
                onChange={handleChange}
              />


              <TextField
                fullWidth
                label="Ağırlık (gr)"
                name="agirlik"
                id="agirlik"
                type="text"
                variant="outlined"
                value={info.agirlik}
                onChange={handleChange}
              />
            </Box>

            <Box>

              <Typography variant='subtitle2' align='center'>
                Çap (gr)
              </Typography>

              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <TextField
                  fullWidth
                  label="A-B Uzun Kenar"
                  name="cap_ab"
                  id="cap_ab"
                  type="text"
                  variant="outlined"
                  value={info.cap_ab}
                  onChange={handleChange}
                />

                <TextField
                  fullWidth
                  label="C-D"
                  name="cap_cd"
                  id="cap_cd"
                  type="text"
                  variant="outlined"
                  value={info.cap_cd}
                  onChange={handleChange}
                />

                <TextField
                  fullWidth
                  label="E1-E2"
                  name="cap_e1e2"
                  id="cap_e1e2"
                  type="text"
                  variant="outlined"
                  value={info.cap_e1e2}
                  onChange={handleChange}
                />
              </Box>

            </Box>

            <Box>

              <Typography variant='subtitle2' align='center'>
                Yükseklik (mm)
              </Typography>

              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <TextField
                  fullWidth
                  label="A"
                  name="yukseklik_a"
                  id="yukseklik_a"
                  type="text"
                  variant="outlined"
                  value={info.yukseklik_a}
                  onChange={handleChange}
                />

                <TextField
                  fullWidth
                  label="B"
                  name="yukseklik_b"
                  id="yukseklik_b"
                  type="text"
                  variant="outlined"
                  value={info.yukseklik_b}
                  onChange={handleChange}
                />

                <TextField
                  fullWidth
                  label="C"
                  name="yukseklik_c"
                  id="yukseklik_c"
                  type="text"
                  variant="outlined"
                  value={info.yukseklik_c}
                  onChange={handleChange}
                />

                <TextField
                  fullWidth
                  label="D"
                  name="yukseklik_d"
                  id="yukseklik_d"
                  type="text"
                  variant="outlined"
                  value={info.yukseklik_d}
                  onChange={handleChange}
                />
              </Box>

            </Box>

            <TextField
              fullWidth
              label="İç Yükseklik (mm)"
              name="icYukseklik"
              id="icYukseklik"
              type="text"
              variant="outlined"
              value={info.icYukseklik}
              onChange={handleChange}
            />

            <Box>

              <Typography variant='subtitle2' align='center'>
                Dudak (mm)
              </Typography>

              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <TextField
                  fullWidth
                  label="A"
                  name="dudak_a"
                  id="dudak_a"
                  type="text"
                  variant="outlined"
                  value={info.dudak_a}
                  onChange={handleChange}
                />

                <TextField
                  fullWidth
                  label="B"
                  name="dudak_b"
                  id="dudak_b"
                  type="text"
                  variant="outlined"
                  value={info.dudak_b}
                  onChange={handleChange}
                />

                <TextField
                  fullWidth
                  label="C"
                  name="dudak_c"
                  id="dudak_c"
                  type="text"
                  variant="outlined"
                  value={info.dudak_c}
                  onChange={handleChange}
                />

                <TextField
                  fullWidth
                  label="D"
                  name="dudak_d"
                  id="dudak_d"
                  type="text"
                  variant="outlined"
                  value={info.dudak_d}
                  onChange={handleChange}
                />
              </Box>

            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>

              <TextField
                fullWidth
                label="Ayak Yüksekliği"
                name="ayakYuksekligi"
                id="ayakYuksekligi"
                type="text"
                variant="outlined"
                value={info.ayakYuksekligi}
                onChange={handleChange}
              />

              <TextField
                fullWidth
                label="Bombe Çökme"
                name="bombeCokme"
                id="bombeCokme"
                type="text"
                variant="outlined"
                value={info.bombeCokme}
                onChange={handleChange}
              />

              <TextField
                fullWidth
                label="Düzlemden Sapma"
                name="duzlemdenSapma"
                id="duzlemdenSapma"
                type="text"
                variant="outlined"
                value={info.duzlemdenSapma}
                onChange={handleChange}
              />

            </Box>

            <TextField
              multiline
              fullWidth
              label="Açıklama"
              name="aciklama"
              id="aciklama"
              type="text"
              variant="outlined"
              value={info.aciklama}
              onChange={handleChange}
            />




            <Button
              variant='contained'
              fullWidth
              type='submit'
            >
              {info?.id ? "Update Data" : "Add New Data"}
            </Button>


          </Box>


        </Box>
      </Modal>
    </div>
  );
}

export default NihaiUrunKontrolModal